import { DistributionListSport } from '@/types/dde/distributionList'

export const distributionListSportLabelsMap: { [key in DistributionListSport]: string } = {
  'AMERICAN-FOOTBALL': 'American Football',
  BASKETBALL: 'Basketball',
  CRICKET: 'Cricket',
  'ICE-HOCKEY': 'Ice Hockey',
  SNOOKER: 'Snooker',
  SOCCER: 'Soccer',
  TABLETENNIS: 'Table Tennis',
  VOLLEYBALL: 'Volleyball - via Genius ',
  'VOLLEYBALL-MSFP': 'Volleyball - via Multisport ',
  GOLF: 'Golf'
} as const

export type DistributionListSportKey = keyof typeof distributionListSportLabelsMap
export const possibleDistributionListSports = Object.keys(
  distributionListSportLabelsMap
) as DistributionListSportKey[]

export const possibleRecipientTypes: ['ADMIN', 'OPERATOR'] = ['ADMIN', 'OPERATOR'] // idk why for recipient type they use UPPERCASE, but for the roles in the rest of the app they use camelCase
export type DistributionListRecipientType = (typeof possibleRecipientTypes)[number]
